import { ShieldCheck } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-line bg-base py-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <ShieldCheck className="w-5 h-5 text-cyan-400" />
          <span className="font-display font-bold">ANAYA<span className="text-cyan-400">.</span> CCTV Security Solutions</span>
        </div>
        <p className="font-mono2 text-[11px] tracking-[0.18em] text-strong0 uppercase text-center">
          Ghaziabad · Delhi NCR · +91 70113 64764
        </p>
      </div>
    </footer>
  );
}
